import { COLORS, Typography } from '@musinsa/mds';
import styled from 'styled-components';

import type { GiftDetail } from '@/shared/@types';
import type { FC } from 'react';

type GiftNoticeProps = {
  notice: GiftDetail['notice'];
};

const DEFAULT_NOTICES = [
  '일반 택배 배송이 아닌 매장픽업, 화물 직배송(가구/설치)등은 사은품 증정이 제외됩니다.',
  '가상계좌(무통장) 등은 입금 확인 전까지 사은품이 소진될 수 있습니다.',
  '상품을 환불할 경우 함께 받은 사은품까지 모두 반품해야 합니다.',
  '사은품이 반납되지 않으면 사은품 원가격만큼 환불 금액에서 차감됩니다.',
  '사은품은 구매 수량이 아닌 주문 건을 기준으로 적용합니다.',
  '사은품 증정은 한정 수량으로 재고 소진 시 종료됩니다.',
  '본 상품은 이벤트성 상품으로 쿠폰이나 적립금 등의 사용이 제한됩니다.',
];

const GiftNotice: FC<GiftNoticeProps> = ({ notice }) => {
  const customNotices = notice.split('\n').filter((line) => line.trim());
  const allNotices = [...DEFAULT_NOTICES, ...customNotices];

  return (
    <S.Container>
      <S.SectionTitle>
        <Typography variant="body14pxMed" colorScheme="black">
          유의 사항
        </Typography>
      </S.SectionTitle>

      <ul>
        {allNotices.map((noticeItem, index) => (
          <S.NoticeItem key={index}>
            <Typography variant="body13pxReg" colorScheme="gray-600">
              {noticeItem}
            </Typography>
          </S.NoticeItem>
        ))}
      </ul>
    </S.Container>
  );
};

const S = {
  Container: styled.section`
    padding: 12px 16px;
  `,
  SectionTitle: styled.h2`
    padding-bottom: 4px;
  `,
  NoticeItem: styled.li`
    position: relative;
    padding: 2px 0 2px 10px;

    &::before {
      content: '•';
      position: absolute;
      left: 0;
      color: ${COLORS.gray[600]};
    }
  `,
};

export { GiftNotice };
